import {useIsMobile} from '@legit.health/ui';
import {useCurrentPatient} from '@/patient/context/CurrentPatientContext';
import {useCompany} from '@/shared/contexts/UserContext/useUserContext';

interface CanUploadPhotosResult {
  canUploadPhotos: boolean;
  restrictionReason: 'mobileOnly' | 'notAllowed' | null;
}

export default function useCanUploadPhotos(): CanUploadPhotosResult {
  const patient = useCurrentPatient();
  const isMobile = useIsMobile();
  const company = useCompany();

  if (!patient.isAllowedToUploadPhotos || !company.isTakePhotoEnabledForPatient) {
    return {
      canUploadPhotos: false,
      restrictionReason: 'notAllowed'
    };
  }

  if (patient.isMobileOnlyPhotoEnabled && !isMobile) {
    return {
      canUploadPhotos: false,
      restrictionReason: 'mobileOnly'
    };
  }

  return {
    canUploadPhotos: true,
    restrictionReason: null
  };
}
